import React from 'react';
import styles from './RadioGroupComponent.module.css';
import RadioComponent from '../RadioComponent/RadioComponent'; // Adjust path if necessary

const RadioGroupComponent = ({
  label,
  name,
  options,
  selectedValue,
  onChange,
}) => {
  return (
    <div className={styles.radioGroup}>
      <span className={styles.radioLabel}>{label}</span>
      <div className={styles.radioOptions}>
        {options.map((opt, index) => (
          <RadioComponent
            key={index}
            name={name}
            value={opt.value}
            label={opt.label}
            checked={selectedValue === opt.value}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  );
};

export default RadioGroupComponent;
